import { render, staticRenderFns } from "./OxyClassToken.vue?vue&type=template&id=0131901c&"
import script from "./OxyClassToken.vue?vue&type=script&lang=ts&"
export * from "./OxyClassToken.vue?vue&type=script&lang=ts&"
import style0 from "./OxyClassToken.vue?vue&type=style&index=0&id=0131901c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports